import { useEffect, useState } from "react";
import { Accordion, AccordionItem, Form, Modal } from "react-bootstrap";
import Select from "react-select";
import { dealerSignal } from "../../../signal/dealerSignal";
import { productSignal } from "../../../signal/productSignal";
import { useMutation, useQuery } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";
import { toast } from "react-toastify";
import MapModal from "../maps/MapModal";
import CreatableSelect from 'react-select/creatable';
import { confirmAlert } from "react-confirm-alert";
import { stateNameFormatter } from "../../../utilities/stateNameFormatter";
import { stateNames } from "../../../utilities/stateNames";
import { organisationSignal } from "../../../signal/organisationSignal";
import * as moment from "moment";


export default function AddEditOrder(props) {

    const [order, setOrder] = useState(props?.order ? props.order : {
        id: '',
        dealerId: '',
        dealerState: '',
        orderItems: [],
        subTotal: 0,
        totalAmount: 0,
        taxes: [],
        tallySalesVoucherDetails: {
            priceLevel: ""
        },
        shippingCharges: 0,
        userCommissionInPercentage: 0,
        shippingAddress: {
            addressL1: '',
            landmark: '',
            area: '',
            city: '',
            state: '',
            pincode: '',
            country: ''
        },
        billingAddress: {
            addressL1: '',
            landmark: '',
            area: '',
            city: '',
            state: '',
            pincode: '',
            country: ''
        },
        note: '',
        createdAt: moment().valueOf()
    });
    const [showMap, setShowMap] = useState(false)
    const [oldOrdertItems, setOldOrderItems] = useState(null)

    const [products, setProducts] = useState(null);

    const getProducts = useQuery("products", async () => {
        let resp = await axios.get(`${DEV_SERVER}/product/v2`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                let temp = order?.products ? order?.products : {}
                data?.data?.map((product) => {
                    temp[product.id] = product
                })

                setProducts(temp)
                productSignal.value = temp

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const updateOrder = useMutation(async (data) => {
        let resp = await axios.put(`${DEV_SERVER}/order/v2/${data?.id}`, data?.body, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                toast.success(data.message);

                if (oldOrdertItems !== null) {
                    let oldItemsMap = {}
                    oldOrdertItems.map((oldItem) => {
                        if (!oldItemsMap[`${oldItem.productId}-${oldItem.packagingType}`]) {
                            oldItemsMap[`${oldItem.productId}-${oldItem.packagingType}`] = {
                                productId: oldItem.productId,
                                quantity: oldItem?.quantity || 0,
                                packagingType: oldItem.packagingType,
                                discount: oldItem.discount,
                                price: oldItem.price
                            }
                        } else {
                            let tempQty = oldItemsMap[`${oldItem.productId}-${oldItem.packagingType}`]?.quantity
                            oldItemsMap[`${oldItem.productId}-${oldItem.packagingType}`] = {
                                productId: oldItem.productId,
                                quantity: tempQty + oldItem?.quantity || 0,
                                packagingType: oldItem.packagingType,
                                discount: oldItem.discount,
                                price: oldItem.price
                            }
                        }
                    })

                    let newItemsMap = {}
                    order?.orderItems.map((newItem) => {
                        if (!newItemsMap[`${newItem.productId}-${newItem.packagingType}`]) {
                            newItemsMap[`${newItem.productId}-${newItem.packagingType}`] = newItem?.quantity || 0
                        } else {
                            newItemsMap[`${newItem.productId}-${newItem.packagingType}`] += newItem?.quantity || 0
                        }
                    })

                    // items to be added as another order
                    let itemsToAdd = []
                    Object.keys(oldItemsMap).map((key) => {
                        if (newItemsMap[key] === undefined) {
                            itemsToAdd.push({
                                productId: key.split("-")[0],
                                quantity: oldItemsMap[key]?.quantity,
                                packagingType: key.split("-")[1],
                                discount: oldItemsMap[key]?.discount,
                                price: oldItemsMap[key]?.price
                            })
                        } else if (newItemsMap[key] < oldItemsMap[key]?.quantity) {
                            itemsToAdd.push({
                                productId: key.split("-")[0],
                                quantity: oldItemsMap[key]?.quantity - newItemsMap[key],
                                packagingType: key.split("-")[1],
                                discount: oldItemsMap[key]?.discount,
                                price: oldItemsMap[key]?.price
                            })
                        }
                    })

                    if (itemsToAdd.length > 0) {
                        props.refetchOrder()
                        props.close()

                        confirmAlert({

                            title: 'Confirm to submit',
                            message: `Do you want to add the remaining items as another order? \n ${itemsToAdd.map((item) => {
                                return `${products[item.productId]?.name} - ${item.quantity} (${item.packagingType})`
                            }).join(",\n")}`,
                            buttons: [
                                {
                                    label: 'Yes',
                                    onClick: () => {
                                        let temp = {}
                                        temp.body = {
                                            ...order,
                                            dealerId: order?.dealerId,
                                            orderItems: itemsToAdd,
                                            discounts: [],
                                            taxes: [],
                                            shippingCharges: 0,
                                            shippingAddress: order?.shippingAddress,
                                            billingAddress: order?.billingAddress,
                                            userCommissionInPercentage: 0,
                                            note: order?.note
                                        }
                                        addOrder.mutate(temp.body)
                                    }
                                },
                                {
                                    label: 'No',
                                    onClick: () => {
                                        props.refetchOrder()
                                        props.close()
                                    }
                                }
                            ]
                        });
                    } else {
                        props.refetchOrder()
                        props.close()
                    }

                } else {
                    props.refetchOrder()
                    props.close()
                }
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            }
        }
    });

    const addOrder = useMutation(async (data) => {
        let resp = await axios.post(`${DEV_SERVER}/order/v2`, data, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                toast.success(data.message);
                props.refetchOrder()
                props.close()
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            }
        }
    })

    useEffect(() => {

        if (products === null) {
            if (productSignal.value !== null) {
                setProducts({ ...productSignal.value, ...order?.products })
            } else {
                getProducts.refetch({ cancelRefetch: true })
            }
        }

        if (props?.order) {
            setOrder(props.order);
            if (oldOrdertItems === null) {
                let temp = []
                if (props?.order?.orderItems) {
                    temp = JSON.parse(JSON.stringify(props?.order?.orderItems))
                }
                setOldOrderItems(temp || [])
            }
        }
    }, [props?.order]);

    const handleLocationSelecion = (selectedCoordinates, address) => {
        setOrder({
            ...order,
            shippingAddress: address.area,
            shippingCity: address.city,
            shippingState: address.state,
            shippingPincode: address.pincode.toString()
        })
    }

    const handleSubmit = async () => {

        if (order?.dealerId === '' || order?.dealerId === null || order?.dealerId === "000000000000000000000000") {
            toast.error("Dealer is required")
            return
        }

        let ok = true;

        if (order?.orderItems?.length === 0) {
            toast.error("Order Items are required")
            return
        }

        if (order?.orderItems?.length > 0 || order?.taxes?.length > 0) {
            if (order?.orderItems?.length > 0) {

                await new Promise((resolve, reject) => {
                    order?.orderItems?.map(async (orderItem, index) => {
                        if (orderItem?.productId === "") {
                            toast.error(`Order Item ${index + 1} product is required`);
                            reject();
                        }

                        if (orderItem?.quantity === 0) {
                            toast.error(`Order Item ${index + 1} quantity is required`);
                            reject();
                        }

                        if (orderItem?.price === 0) {
                            toast.error(`Order Item ${index + 1} price is required`);
                            reject();
                        }

                        if (orderItem?.packagingType === "") {
                            toast.error(`Order Item ${index + 1} packaging type is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    ok = false
                })
            }

            if (order?.taxes?.length > 0) {
                await new Promise((resolve, reject) => {
                    order?.taxes?.map((tax, index) => {
                        if (tax?.name === "") {
                            toast.error(`Tax ${index + 1} name is required`);
                            reject();
                        }

                        if (tax?.taxInAmount === 0) {
                            toast.error(`Tax ${index + 1} tax in amount is required`);
                            reject();
                        }
                    })
                    resolve()
                }).catch(err => {
                    ok = false
                })
            }
        }

        if (!ok) {
            return
        }

        let temp = {}
        temp.body = {
            dealerId: order?.dealerId,
            dealerState: order?.dealerState,
            orderItems: order?.orderItems,
            taxes: order?.taxes,
            tallySalesVoucherDetails: order?.tallySalesVoucherDetails,
            shippingCharges: order?.shippingCharges,
            shippingAddress: order?.shippingAddress,
            billingAddress: order?.billingAddress,
            userCommissionInPercentage: order?.userCommissionInPercentage,
            note: order?.note,
            createdAt: order?.createdAt
        }

        temp.id = order?.id

        if (props?.order) {
            updateOrder.mutate(temp)
        } else {
            addOrder.mutate(temp.body)
        }


    }

    const handleTaxes = () => {

        let cgst = 0
        let sgst = 0
        let igst = 0
        let _subTotal = 0

        for (let i = 0; i < order?.orderItems?.length; i++) {
            let _amount = ((order?.orderItems[i]?.price * order?.orderItems[i]?.quantity) * ((100 - order?.orderItems[i]?.discount) / 100)) || 0


            if (products[order?.orderItems[i]?.productId]?.isTaxEnabled) {
                if (products[order?.orderItems[i]?.productId]?.taxRates) {
                    Object.keys(products[order?.orderItems[i]?.productId]?.taxRates).map((tax) => {
                        if (tax?.startsWith("CGST")) {
                            cgst += (_amount * products[order?.orderItems[i]?.productId]?.taxRates[tax]) / 100
                        } else if (tax?.startsWith("SGST")) {
                            sgst += (_amount * products[order?.orderItems[i]?.productId]?.taxRates[tax]) / 100
                        } else if (tax?.startsWith("IGST")) {
                            igst += (_amount * products[order?.orderItems[i]?.productId]?.taxRates[tax]) / 100
                        }
                    })
                }
            }

            _subTotal += _amount

        }

        let temp = [...order?.taxes]

        let cgstIndex = temp.findIndex((tax) => tax?.name === "CGST")
        let sgstIndex = temp.findIndex((tax) => tax?.name === "SGST")
        let igstIndex = temp.findIndex((tax) => tax?.name === "IGST")

        if (organisationSignal?.value?.state === order?.dealerState) {

            if (cgst !== 0) {
                if (cgstIndex === -1) {
                    temp.push({
                        name: "CGST",
                        taxInPercentage: 0,
                        taxInAmount: cgst,
                        isTaxedOnProduct: true
                    })
                } else {
                    temp[cgstIndex].taxInAmount = cgst
                    temp[cgstIndex].isTaxedOnProduct = true
                }
            }

            if (sgst !== 0) {
                if (sgstIndex === -1) {
                    temp.push({
                        name: "SGST",
                        taxInPercentage: 0,
                        taxInAmount: sgst,
                        isTaxedOnProduct: true
                    })
                } else {
                    temp[sgstIndex].taxInAmount = sgst
                    temp[sgstIndex].isTaxedOnProduct = true
                }
            }
        } else {


            if (igst !== 0) {
                if (igstIndex === -1) {
                    temp.push({
                        name: "IGST",
                        taxInPercentage: 0,
                        taxInAmount: igst,
                        isTaxedOnProduct: true
                    })
                } else {
                    temp[igstIndex].taxInAmount = igst
                    temp[igstIndex].isTaxedOnProduct = true
                }
            }
        }

        setOrder({
            ...order,
            taxes: temp,
            subTotal: _subTotal
        })
    }

    useEffect(() => {
        if (products !== null) {
            handleTaxes()
        }
    }, [order?.orderItems])

    return (
        <>
            {products === null ? <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <div className="spinner-border text-primary m-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
                :
                <Modal fullscreen show={props?.show} onHide={props?.close} style={{ height: "100%", width: "100%" }}>
                    <Modal.Header closeButton>
                        <Modal.Title>{props?.order ? 'Edit' : 'Add'} Order</Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="">
                        <Form className="w-75 mx-auto d-flex flex-column justify-content-center align-items-center">
                            <Form.Group className="w-100 mx-2" controlId="formBasicDealer">
                                <Form.Label>Dealer</Form.Label>
                                <Form.Control type="date"
                                    value={moment(order?.createdAt).format("YYYY-MM-DD")}
                                    onChange={(e) =>
                                        setOrder({
                                            ...order,
                                            createdAt: moment(e.target.value).valueOf()
                                        })
                                    }
                                />
                            </Form.Group>
                            <Form.Group className="w-100 mx-2" controlId="formBasicDealer">
                                <Form.Label>Dealer</Form.Label>
                                <Select
                                    as="select"
                                    value={{ label: dealerSignal.value[order?.dealerId]?.name, value: order?.dealerId }}
                                    onChange={(e) => {

                                        let dealerDetails = dealerSignal.value[e?.value]

                                        let _delaerState = stateNameFormatter(dealerDetails?.state)
                                        let _priceLevel = ""

                                        let _dealerTallyDetails = dealerDetails?.tallyDetails || []
                                        let idx = -1
                                        for (let i = 0; i < _dealerTallyDetails.length; i++) {
                                            if (_dealerTallyDetails[i]?.priceLevel !== "" && _dealerTallyDetails[i]?.priceLevel !== null && _dealerTallyDetails[i]?.priceLevel !== undefined) {
                                                idx = i
                                                break
                                            }
                                        }

                                        if (idx !== -1) {
                                            _priceLevel = _dealerTallyDetails[idx]?.priceLevel
                                        }

                                        setOrder({
                                            ...order,
                                            dealerId: e?.value,
                                            dealerState: _delaerState,
                                            billingAddress: {
                                                addressL1: dealerDetails?.address,
                                                city: dealerDetails?.city,
                                                state: dealerDetails?.state,
                                                pincode: dealerDetails?.pincode.toString()
                                            },
                                            shippingAddress: {
                                                addressL1: dealerDetails?.address,
                                                city: dealerDetails?.city,
                                                state: dealerDetails?.state,
                                                pincode: dealerDetails?.pincode.toString()
                                            },
                                            tallySalesVoucherDetails: {
                                                priceLevel: _priceLevel
                                            }
                                        })

                                    }}
                                    options={Object.entries(dealerSignal?.value).map(([key, value]) => {
                                        return (
                                            {
                                                label: value?.name,
                                                value: key.toString()
                                            }
                                        )
                                    })}
                                    isSearchable
                                    isClearable
                                />
                            </Form.Group>

                            <Form.Group className="w-100 mx-2 mt-3" controlId="formBasicNote">
                                <Form.Label>Dealer's State</Form.Label>
                                <Select as="select"
                                    value={{ label: order?.dealerState, value: order?.dealerState }}
                                    onChange={(e) => {
                                        setOrder({
                                            ...order,
                                            dealerState: e?.value
                                        });
                                    }}
                                    options={stateNames.map((state) => {
                                        return (
                                            { label: state, value: state }
                                        )
                                    })}
                                    isSearchable
                                />
                            </Form.Group>

                            {organisationSignal?.value?.isTallyIntegrationActivated && <Form.Group className="w-100 mx-2 mt-3" controlId="formBasicNote">
                                <Form.Label>Price Level</Form.Label>
                                <Select as="select"
                                    value={{ label: order?.tallySalesVoucherDetails?.priceLevel, value: order?.tallySalesVoucherDetails?.priceLevel }}
                                    onChange={(e) => {
                                        if (e && e?.value) {
                                            setOrder({
                                                ...order,
                                                tallySalesVoucherDetails: {
                                                    ...order?.tallySalesVoucherDetails,
                                                    priceLevel: e?.value
                                                }
                                            });
                                        } else {
                                            setOrder({
                                                ...order,
                                                tallySalesVoucherDetails: {
                                                    ...order?.tallySalesVoucherDetails,
                                                    priceLevel: ""
                                                }
                                            });
                                        }
                                    }}
                                    isSearchable
                                    isClearable
                                />
                            </Form.Group>}

                            <div className="mt-5 mx-2" style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Order Items</Accordion.Header>
                                        <Accordion.Body>
                                            <div>
                                                {order?.orderItems?.length > 0 && order?.orderItems?.map((orderItem, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group" style={{ width: "40%" }}>
                                                                    <Form.Label>Product</Form.Label>
                                                                    <Select
                                                                        as="select"
                                                                        value={{ label: products[orderItem?.productId]?.name, value: orderItem?.productId }}
                                                                        onChange={(e) => {
                                                                            let temp = [...order?.orderItems]
                                                                            temp[index].productId = e?.value
                                                                            temp[index].price = products[e?.value]?.price
                                                                            temp[index].quantity = 1
                                                                            temp[index].discount = 0
                                                                            if (products[e?.value]?.tallyVatBaseUnit && products[e?.value]?.tallyVatBaseUnit !== "") {
                                                                                temp[index].packagingType = products[e?.value]?.tallyVatBaseUnit
                                                                            }

                                                                            setOrder({
                                                                                ...order,
                                                                                orderItems: temp
                                                                            });
                                                                        }}
                                                                        options={Object.entries(products).map(([key, value]) => {
                                                                            return (
                                                                                {
                                                                                    label: value?.name,
                                                                                    value: key.toString()
                                                                                }
                                                                            )
                                                                        })}
                                                                        isSearchable
                                                                        isClearable
                                                                    />
                                                                </Form.Group >
                                                                <Form.Group className="form-group" style={{ width: '20%' }}>
                                                                    <Form.Label>Packaging</Form.Label>
                                                                    <CreatableSelect
                                                                        as="select"
                                                                        value={{ label: orderItem?.packagingType, value: orderItem?.packagingType }}
                                                                        onChange={(e) => {
                                                                            let temp = [...order?.orderItems]
                                                                            temp[index].packagingType = e?.value
                                                                            if (products[orderItem?.productId]?.packagingTypesPrices && products[orderItem?.productId]?.packagingTypesPrices[e?.value]) {
                                                                                temp[index].price = products[orderItem?.productId]?.packagingTypesPrices[e?.value]
                                                                            }
                                                                            setOrder({
                                                                                ...order,
                                                                                orderItems: temp
                                                                            });
                                                                        }}
                                                                        options={products[orderItem?.productId]?.packagingTypes?.map((packagingType) => {
                                                                            return (
                                                                                {
                                                                                    label: packagingType,
                                                                                    value: packagingType
                                                                                }
                                                                            )
                                                                        })}
                                                                        isSearchable

                                                                    />
                                                                </Form.Group >
                                                                <Form.Group className="form-group" style={{ width: '10%' }}>
                                                                    <Form.Label>Qty</Form.Label>
                                                                    <Form.Control type="number" className="" id="quantity" aria-describedby="quantity" placeholder="quantity" value={orderItem?.quantity} onChange={(e) => {
                                                                        let temp = [...order?.orderItems]
                                                                        temp[index].quantity = parseInt(e.target.value)
                                                                        if (order?.tallySalesVoucherDetails?.priceLevel !== "" && order?.tallySalesVoucherDetails?.priceLevel !== null && order?.tallySalesVoucherDetails?.priceLevel !== undefined) {
                                                                            if (products[orderItem?.productId]?.tallyPriceList && products[orderItem?.productId]?.tallyPriceList[order?.tallySalesVoucherDetails?.priceLevel]) {
                                                                                let _levels = products[orderItem?.productId]?.tallyPriceList[order?.tallySalesVoucherDetails?.priceLevel]

                                                                                if (_levels?.length > 0) {
                                                                                    let _price = 0
                                                                                    let discount = 0
                                                                                    for (let i = 0; i < _levels.length; i++) {
                                                                                        if (_levels[i]?.startingFrom <= temp[index].quantity && _levels[i]?.endingAt >= temp[index].quantity) {
                                                                                            _price = _levels[i]?.rate
                                                                                            discount = _levels[i]?.discount
                                                                                            break
                                                                                        }
                                                                                    }
                                                                                    temp[index].price = _price
                                                                                    temp[index].discount = discount

                                                                                }

                                                                            }

                                                                        }

                                                                        setOrder({
                                                                            ...order,
                                                                            orderItems: temp
                                                                        });
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group" style={{ width: '20%' }}>
                                                                    <Form.Label>Price</Form.Label>
                                                                    <Form.Control type="number" className="" id="price" aria-describedby="price" placeholder="price" value={orderItem?.price} onChange={(e) => {
                                                                        console.log(e.target.value)
                                                                        let temp = [...order?.orderItems]
                                                                        temp[index].price = parseFloat(e.target.value)
                                                                        setOrder({
                                                                            ...order,
                                                                            orderItems: temp
                                                                        });
                                                                    }} />
                                                                </Form.Group >

                                                                <Form.Group className="form-group">
                                                                    <Form.Label>Discount (in %)</Form.Label>
                                                                    <Form.Control type="number" className="" id="discount" aria-describedby="discount" placeholder="discount" value={orderItem?.discount} onChange={(e) => {
                                                                        let temp = [...order?.orderItems]
                                                                        temp[index].discount = parseFloat(e.target.value)
                                                                        setOrder({
                                                                            ...order,
                                                                            orderItems: temp
                                                                        });
                                                                    }} />
                                                                </Form.Group >

                                                                <Form.Group className="form-group">
                                                                    <Form.Label>Amount</Form.Label>
                                                                    <Form.Control type="text" className="" id="amount" aria-describedby="amount" placeholder="amount" value={
                                                                        ((orderItem?.price * orderItem?.quantity) * ((100 - orderItem?.discount) / 100)) || "NA"
                                                                    } disabled />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...order?.orderItems]
                                                                        temp.splice(index, 1)
                                                                        setOrder({
                                                                            ...order,
                                                                            orderItems: temp
                                                                        });
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <button className='btn btn-light mt-2' onClick={(e) => {
                                                        e.preventDefault()
                                                        let temp = [...order?.orderItems || []] || []
                                                        temp.push({
                                                            productId: "",
                                                            quantity: 0,
                                                            price: 0,
                                                            discount: 0,
                                                            packagingType: ""
                                                        })
                                                        setOrder({
                                                            ...order,
                                                            orderItems: temp
                                                        });
                                                    }}>Add Item</button>

                                                    <span className="float-right">
                                                        <b>Total:</b> ₹ {order?.subTotal}
                                                    </span>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>

                            <div className="mx-2 mt-5" style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Taxes</Accordion.Header>
                                        <Accordion.Body>
                                            <div>
                                                {(order?.taxes && order?.taxes?.length) > 0 && order?.taxes?.map((tax, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" disabled={tax?.isTaxedOnProduct} placeholder="name" value={tax?.name} onChange={(e) => {
                                                                        let temp = [...order?.taxes]
                                                                        temp[index].name = e.target.value
                                                                        setOrder({
                                                                            ...order,
                                                                            taxes: temp
                                                                        });
                                                                    }} />
                                                                </Form.Group >
                                                                {tax?.isTaxedOnProduct === false && <Form.Group className="form-group" style={{ width: '20%' }}>
                                                                    <Form.Control type="number" className="" id="taxInPercentage" aria-describedby="taxInPercentage" placeholder="Tax in %" value={tax?.taxInPercentage} onChange={(e) => {
                                                                        let temp = [...order?.taxes]
                                                                        temp[index].taxInPercentage = parseFloat(e.target.value)

                                                                        temp[index].taxInAmount = (order?.subTotal * temp[index].taxInPercentage) / 100

                                                                        setOrder({
                                                                            ...order,
                                                                            taxes: temp
                                                                        });
                                                                    }} />
                                                                </Form.Group >}
                                                                <Form.Group className="form-group" style={{ width: '20%' }}>
                                                                    <Form.Control type="number" className="" id="taxInAmount" aria-describedby="taxInAmount" placeholder="Tax in Amount" value={tax?.taxInAmount} disabled />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...order?.taxes]
                                                                        temp.splice(index, 1)
                                                                        setOrder({
                                                                            ...order,
                                                                            taxes: temp
                                                                        });
                                                                    }
                                                                    }></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                )}
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <button className='btn btn-light mt-2' onClick={(e) => {
                                                        e.preventDefault()
                                                        let temp = [...order?.taxes || []] || []
                                                        temp.push({
                                                            name: "",
                                                            taxInPercentage: 0,
                                                            taxInAmount: 0,
                                                            isTaxedOnProduct: false
                                                        })
                                                        setOrder({
                                                            ...order,
                                                            taxes: temp
                                                        });
                                                    }}>Add Item</button>

                                                    <span className="float-right">
                                                        <b>Total:</b> ₹ {order?.subTotal + order?.taxes?.reduce((acc, tax) => {
                                                            return (acc + tax?.taxInAmount) || 0
                                                        }, 0)
                                                        }
                                                    </span>

                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>

                            <div className="mx-2 mt-5" style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Other</Accordion.Header>
                                        <Accordion.Body>
                                            <div>
                                                <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                    <Form.Group className="form-group">
                                                        <Form.Label>Shipping Charges</Form.Label>
                                                        <Form.Control type="number" className="" id="shippingCharges" aria-describedby="shippingCharges" placeholder="Shipping Charges" value={order?.shippingCharges} onChange={(e) => {
                                                            setOrder({
                                                                ...order,
                                                                shippingCharges: parseFloat(e.target.value)
                                                            });
                                                        }} />
                                                    </Form.Group >
                                                    {(order?.userId !== '' && order?.userId !== "000000000000000000000000" && order?.userId !== undefined && order?.userId !== null) &&
                                                        <Form.Group className="form-group">
                                                            <Form.Label>Employee's Commission In Percentage</Form.Label>
                                                            <Form.Control type="number" className="" id="userCommissionInPercentage" aria-describedby="userCommissionInPercentage" placeholder="User Commission In Percentage" value={order?.userCommissionInPercentage} onChange={(e) => {
                                                                setOrder({
                                                                    ...order,
                                                                    userCommissionInPercentage: parseFloat(e.target.value)
                                                                });
                                                            }} />
                                                        </Form.Group >
                                                    }


                                                </div>

                                                <div className="d-flex justify-content-end w-100">
                                                    <span className="align-self-end">
                                                        <b>Total:</b> ₹ {order?.subTotal + order?.taxes?.reduce((acc, tax) => {
                                                            return (acc + tax?.taxInAmount) || 0
                                                        }, 0) + (order?.shippingCharges || 0)}
                                                    </span>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>

                            <div className="w-75 mt-5">
                                <h3>Billing adress</h3>
                            </div>

                            <div className="w-75 mt-3 d-flex justify-content-between">
                                <Form.Group className="mb-3 col-6 me-2" controlId="formBasicAddress">
                                    <Form.Label>Address Line 1</Form.Label>
                                    <div className="d-flex align-items-center" style={{ columnGap: "0.5rem" }}>
                                        <Form.Control value={order?.billingAddress?.addressL1} onChange={(e) => setOrder({ ...order, billingAddress: { ...order?.billingAddress, addressL1: e.target.value } })} type="search" placeholder="Enter address" />
                                        <i className="fa fa-map" style={{ cursor: "pointer", color: '#096DD9' }} onClick={() => {
                                            setShowMap(true)
                                        }} />
                                    </div>
                                </Form.Group>

                                <Form.Group className="mb-3 col-6 me-2" controlId="formBasicCity">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control value={order?.billingAddress?.city} onChange={(e) => setOrder({ ...order, billingAddress: { ...order?.billingAddress, city: e.target.value } })}
                                        type="text" placeholder="Enter city" />
                                </Form.Group>

                            </div>

                            <div className="w-75 mt-3 d-flex justify-content-between">

                                <Form.Group className="mb-3 col-6 me-2" controlId="formBasicPincode">
                                    <Form.Label>Pincode</Form.Label>
                                    <Form.Control value={order?.billingAddress?.pincode} onChange={(e) => setOrder({ ...order, billingAddress: { ...order?.billingAddress, pincode: e.target.value } })}
                                        type="text" placeholder="Enter pincode" />
                                </Form.Group>

                                <Form.Group className="mb-3 col-6 me-2" controlId="formBasicState">
                                    <Form.Label>State</Form.Label>
                                    <Form.Control value={order?.billingAddress?.state} onChange={(e) => setOrder({ ...order, billingAddress: { ...order?.billingAddress, state: e.target.value } })}
                                        type="text" placeholder="Enter state" />
                                </Form.Group>
                            </div>

                            <div className="w-75 mt-5">
                                <h3>Shipping Address</h3>
                            </div>

                            <div className="w-75 mt-3 d-flex justify-content-between">
                                <Form.Group className="mb-3 col-6 me-2" controlId="formBasicAddress">
                                    <Form.Label>Address Line 1</Form.Label>
                                    <div className="d-flex align-items-center" style={{ columnGap: "0.5rem" }}>
                                        <Form.Control value={order?.shippingAddress?.addressL1} onChange={(e) => setOrder({ ...order, shippingAddress: { ...order?.shippingAddress, addressL1: e.target.value } })} type="search" placeholder="Enter address" />
                                        <i className="fa fa-map" style={{ cursor: "pointer", color: '#096DD9' }} onClick={() => {
                                            setShowMap(true)
                                        }} />
                                    </div>
                                </Form.Group>

                                <Form.Group className="mb-3 col-6 me-2" controlId="formBasicCity">
                                    <Form.Label>City</Form.Label>
                                    <Form.Control value={order?.shippingAddress?.city} onChange={(e) => setOrder({ ...order, shippingAddress: { ...order?.shippingAddress, city: e.target.value } })}
                                        type="text" placeholder="Enter city" />
                                </Form.Group>

                            </div>

                            <div className="w-75 mt-3 d-flex justify-content-between">

                                <Form.Group className="mb-3 col-6 me-2" controlId="formBasicPincode">
                                    <Form.Label>Pincode</Form.Label>
                                    <Form.Control value={order?.shippingAddress?.pincode} onChange={(e) => setOrder({ ...order, shippingAddress: { ...order?.shippingAddress, pincode: e.target.value } })}
                                        type="text" placeholder="Enter pincode" />
                                </Form.Group>

                                <Form.Group className="mb-3 col-6 me-2" controlId="formBasicState">
                                    <Form.Label>State</Form.Label>
                                    <Form.Control value={order?.shippingAddress?.state} onChange={(e) => setOrder({ ...order, shippingAddress: { ...order?.shippingAddress, state: e.target.value } })}
                                        type="text" placeholder="Enter state" />
                                </Form.Group>
                            </div>


                            <Form.Group className="mt-3 w-75" controlId="formBasicNote">
                                <Form.Label>Note</Form.Label>
                                <Form.Control as="textarea" rows={3} value={order?.note} onChange={(e) => {
                                    setOrder({
                                        ...order,
                                        note: e.target.value
                                    });
                                }} />
                            </Form.Group>
                        </Form>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="btn btn-light" onClick={props?.onHide}>Close</button>
                        {props?.order ?
                            <button className="btn btn-primary" disabled={updateOrder.isLoading} onClick={handleSubmit}>Update Order</button>
                            :
                            <button className="btn btn-primary" disabled={addOrder.isLoading} onClick={handleSubmit}>Add Order</button>

                        }
                    </Modal.Footer>

                    {showMap && <MapModal show={showMap} onHide={() => setShowMap(false)} zoom={18} handleLocation={handleLocationSelecion} />}

                </Modal>
            }
        </>

    );
}